import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LoadingTexteBackdrop(props) {
    const open = props.openLoadingSimpleBackdrop;

    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
            open={open}
        >
            <CircularProgress color="inherit" />
            <Typography variant="h6" sx={{ textAlign: 'center', maxWidth: '80%' }}>
                Veuillez patienter... Cela peut prendre un peu de temps.
            </Typography>
        </Backdrop>
    );
}
